import React, { useState, useEffect } from 'react';
import { FiDownload, FiCheck } from 'react-icons/fi';
import usePWAInstall from '../hooks/usePWAInstall';
import '../styles/InstallButton.css';

const InstallButton = () => {
  const { canInstall, isInstalled, install } = usePWAInstall();
  const [isInstalling, setIsInstalling] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleInstallClick = async () => {
    if (!canInstall) return;
    
    try {
      setIsInstalling(true);
      await install();
    } catch (error) {
      console.error('Error installing app:', error);
    } finally {
      setIsInstalling(false);
    }
  };

  // Don't show the button if the app is already installed or can't be installed
  if (isInstalled || !canInstall) return null;

  return (
    <div className="install-button-container">
      <button 
        className={`install-button ${isInstalling ? 'installing' : ''}`}
        onClick={handleInstallClick}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
        disabled={isInstalling}
        aria-label="Install app"
        aria-describedby="install-tooltip"
      >
        {isInstalling ? (
          <span className="install-button-text">Installing...</span>
        ) : (
          <>
            <FiDownload className="install-icon" />
            <span className="install-button-text">Install App</span>
          </>
        )}
      </button>
      
      {showTooltip && (
        <div className="tooltip" id="install-tooltip" role="tooltip">
          Add to home screen
          <span className="tooltip-arrow" />
        </div>
      )}
    </div>
  );
};

export default InstallButton;
